/* Shared plate-character helpers for the Names page.
   On an exact-spelling plate every digit stands in for a letter, so digits are
   exactly the substitution marks. Used by the register grid, the hero reveal
   and the Finder arrangements. */

export interface CharCell {
  ch: string;
  sub: boolean;
}

export function digitIndexes(display: string): number[] {
  const out: number[] = [];
  display.split('').forEach((ch, i) => {
    if (ch >= '0' && ch <= '9') out.push(i);
  });
  return out;
}

export function toChars(display: string, subIdx: number[]): CharCell[] {
  return display.split('').map((ch, i) => ({ ch, sub: subIdx.indexOf(i) > -1 }));
}

export function plateChars(display: string): CharCell[] {
  return toChars(display, digitIndexes(display));
}

/* ISO 3166 two-letter code -> flag emoji (regional indicator pair).
   The register's language tags are country codes, so we render the country
   flag rather than the bare code. Returns '' for anything not a 2-letter code. */
export function flagEmoji(code: string): string {
  if (!code || code.length !== 2) return '';
  const A = 0x1f1e6;
  const up = code.toUpperCase();
  const a = up.charCodeAt(0);
  const b = up.charCodeAt(1);
  if (a < 65 || a > 90 || b < 65 || b > 90) return '';
  return String.fromCodePoint(A + (a - 65)) + String.fromCodePoint(A + (b - 65));
}

/* Pence -> "£1,234" (no pence). */
export function gbp(pence: number | null | undefined): string {
  if (pence == null || pence <= 0) return '';
  return '£' + Math.round(pence / 100).toLocaleString('en-GB');
}
